"use client";

import { motion, Variants } from "framer-motion";
import { ReactNode } from "react";

interface TransitionWrapperProps {
  children: ReactNode;
  delay?: number;
  className?: string;
  type?: "fadeInUp" | "scaleIn";
}

const variants: Record<"fadeInUp" | "scaleIn", Variants> = {
  fadeInUp: {
    hidden: { opacity: 0, y: 20 },
    visible: {
      opacity: 1,
      y: 0,
      transition: { duration: 0.6, ease: "easeOut" },
    },
  },
  scaleIn: {
    hidden: { opacity: 0, scale: 0.95 },
    visible: {
      opacity: 1,
      scale: 1,
      transition: { duration: 0.5, ease: "backOut" },
    },
  },
};

export const TransitionWrapper = ({
  children,
  delay = 0,
  className = "",
  type = "fadeInUp",
}: TransitionWrapperProps) => {
  return (
    <motion.div
      initial="hidden"
      animate="visible"
      variants={variants[type]}
      transition={{ delay }}
      className={className}
    >
      {children}
    </motion.div>
  );
};
